import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const domain =
  window.location.hostname == 'localhost' ? 'https://ecn.rootcom.jp' : ''
const shoes_default = {
  section1: null,
  section2: null,
  section3: null,
  section4: null,
  section5: null,
  section6: null,
  section7: null,
  section8: null,
  section9: null,
  section10: null,
}

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    section: 1,
    status: '',
    shoes: null,
    total: 0,
    top_ranker: 0,
    rank: null,
  },
  mutations: {
    section(state, payload) {
      if (payload.status.indexOf('section') != -1) {
        // state.section = payload.status.split('_')[1] * 1
        state.section = payload.section
      }
    },
    status(state, payload) {
      state.status = payload.status
    },
    shoes(state, payload) {
      state.shoes = Object.assign(Object.assign({}, shoes_default), payload.shoes)
    },
    total(state, payload) {
      state.total = payload.total
    },
    top_ranker(state, payload) {
      state.top_ranker = payload.top_ranker
    },
    rank(state, payload) {
      state.rank = payload.rank
    },
  },
  actions: {
    getData({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${domain}/ekiden/api/`)
          .then(response => {
            // console.log(response.data)
            commit('section', response.data)
            commit('status', response.data)
            commit('shoes', response.data)
            commit('total', response.data)
            commit('top_ranker', response.data)
            commit('rank', response.data)
            resolve(response.status)
          })
          .catch(error => {
            reject(error.response.status)
          })
          .then(function() {
            // always executed
          })
      })
    },
  },
})
